import React from 'react'
import { withRouter } from 'react-router-dom';

import { Section, Table, InfosBar, Empty, ProfilePicture, Text } from 'components';
import { Container, Icon } from 'semantic-ui-react'

import { BreadcrumbHelper, Typeof } from 'utils';

const EXAMENS_PER_PAGE = 10;

class ClinicExamenListScene extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      examens: props.examens,
      examenCriteria: '',
      showSensorCreateModal: false
    };

    this.handleExamenSearch = this.handleExamenSearch.bind(this);

    this.handleExamenSelect = this.handleExamenSelect.bind(this);
  }

  componentWillMount() {

    BreadcrumbHelper.reset();
    BreadcrumbHelper.push('Accueil', '/');

    BreadcrumbHelper.push('Examens');
    BreadcrumbHelper.flush();
  }

  handleExamenSearch(criteria) {

    this.setState({
      examenCriteria: criteria
    });
  }

  handleExamenSelect(examen) {
    //this.props.history.push(`/clinics/examens/${examen.uuid}`);
  }

  render() {

    const { examens } = this.state;

    let columns = [
      {
        id: 'uuid',
        header: 'UUID',
        value: (examen) => examen.uuid,
        render: (examen) => examen.uuid,
        fit: true
      },
      // {
      //   id: 'name',
      //   header: 'Nom',
      //   value: (examen) => examen.name,
      //   fit: true
      // },
      // {
      //   id: 'owner',
      //   header: 'Propriétaire',
      //   value: (examen) => examen.owner,
      //   render: (examen, owner) => {
      //     if(!Typeof.string(owner)) {
      //       return <Empty />;
      //     }

      //     return (
      //       <Text style={{"capitalize" : true}}>{owner}</Text>
      //     )
      //   },
      //   fit: true
      // },
      // {
      //   id: 'stable',
      //   header: 'Écurie',
      //   value: (examen) => examen.stable,
      //   render: (examen, stable) => {
      //     if(!Typeof.string(stable)) {
      //       return <Empty />;
      //     }

      //     return (
      //       <Text style={{"capitalize" : true}}>{stable}</Text>
      //     )
      //   }
      // },
      // {
      //   id: 'active',
      //   header: 'Actif',
      //   value: (examen) => examen.active,
      //   render: (examen, active) => {

      //     return (
      //       <Icon name={active ? 'checkmark' : 'times'} color={active ? 'green' : 'red'} />
      //     )
      //   },
      //   fit: true
      // }
    ];

    return (
      <React.Fragment>
        <Container>

          {/* Users */}
          <Section title="Examens" onSearch={this.handleExamenSearch} actions={[]}>

            {examens.length > 0 ? (

              <React.Fragment>

                {/* Number of available examens */}
                <InfosBar mode="column">
                  <span>{examens.length > 1 ? `${examens.length} examens disponibles` : '1 examen disponible'}</span>
                </InfosBar>

                {/* examens list */}
                <Table columns={columns}
                  criteria={this.state.examenCriteria}
                  items={examens}
                  itemsPerPage={EXAMENS_PER_PAGE}
                  onSelect={this.handleExamenSelect}
                  messageEmpty="Aucun examen ne correspond à votre recherche"
                  getRowClass={(examen) => !examen.active ? 'warning' : undefined}
                />

              </React.Fragment>

            ) : (

              // No examen available
              <InfosBar mode="row">
                <span>Aucun examen disponible</span>
              </InfosBar>

            )}

          </Section>

        </Container>

      </React.Fragment>
    );
  }
}

export default withRouter(ClinicExamenListScene);
